interface Props {
  color?: string
  width?: number
  height?: number
}

export const InfoIcon = ({ color = '#6F6F6F', width = 9, height = 15 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.85059 5.00977C5.07855 5.05629 5.25 5.25829 5.25 5.5V12H6.5C6.77614 12 7 12.2239 7 12.5C7 12.7761 6.77614 13 6.5 13H3C2.72386 13 2.5 12.7761 2.5 12.5C2.5 12.2239 2.72386 12 3 12H4.25V6H3.75C3.47386 6 3.25 5.77614 3.25 5.5C3.25 5.22386 3.47386 5 3.75 5H4.75L4.85059 5.00977ZM4.5 1C5.19035 1 5.75 1.55965 5.75 2.25C5.75 2.94035 5.19035 3.5 4.5 3.5C3.80965 3.5 3.25 2.94035 3.25 2.25C3.25 1.55965 3.80965 1 4.5 1Z"
        fill={color}
      />
    </svg>
  )
}
